import React from "react";
import { string, func, shape, element } from "prop-types";
import ThemeConsumer from "../ThemeConsumer";
import _get from "lodash/get";
import { MODAL_BUTTON_CLOSE_MODAL_HEADER } from "shared/constants/idsElements"
import styles from "./styles.css"

const ModalHeader = ({ theme, icons, icon, title, onClose, customTheme }) => (
  <div className={theme.navModal}>
    <div className={theme.modalIconText}>
      {icon ? <img className={theme.titleIcon} src={icon} alt="" /> : null}
      <div className={theme[_get(customTheme, "titleText")] || theme.titleText}>
        {title}
      </div>
    </div>
    <div>
      <button
        id={MODAL_BUTTON_CLOSE_MODAL_HEADER}
        className={styles.cursorPointer}
        onClick={onClose}
      >
        <img src={icons.close.type} alt="Close" />
      </button>
    </div>
  </div>
)

ModalHeader.propTypes = {
  theme: shape({
    title: string,
    // TODO: Especificar demais seletores do tema
  }),
  icons: shape({
    close: element,
  }),
  icon: string,
  title: string,
  onClose: func.isRequired,
  customTheme: shape({
    titleText: string,
  }),
};

ModalHeader.defaultProps = {
  theme: {},
  icons: {},
  icon: null,
  title: null,
  customTheme: {},
};

export default ThemeConsumer("UIModal")(ModalHeader);



// WEBPACK FOOTER //
// ./src/shared/components/Modal/ModalHeader.js